import { makeObservable, action } from 'mobx'

import SharedStore from 'shared/stores/shared.store'
import { ApiClientV2Default } from 'utils/api-client/api-client.utils'
import { SessionApi, createSessionApi, Session } from '../api/sessionV2.api'

interface SignInParams {
  get_new_profile_type?: string
  email?: string
  password?: string
  otpAttempt?: string
}

export class SessionV2Store extends SharedStore<Session> {
  storeName = 'SessionV2Store'
  declare childApi: SessionApi

  constructor(root) {
    super()
    this.childApi = createSessionApi(root.apiClient)
    makeObservable(this)
  }

  @action
  async signIn(data: SignInParams, params?: any): Promise<any> {
    const resp = await this.childApi.signIn(data, params)
    return resp
  }
}

export default new SessionV2Store({ apiClient: new ApiClientV2Default() })
